function Actions() {
    return (
        <div id="schedule-drawer" />
    )
}

export default Actions;
